import frameComponent from './frame.component';

const frameModule = angular.module('app.components.iClinica.frame', [])
	.component('iClinicaFrame', frameComponent)
	.name;

export default frameModule;
